// Preload critical components with improved error handling
export const preloadCriticalComponents = () => {
  // Función auxiliar para importar de forma segura
  const safeImport = (path: string) => {
    // Añadimos @vite-ignore para suprimir la advertencia de importación dinámica
    import(/* @vite-ignore */ path).catch(() => {
      // Manejar silenciosamente errores de importación
      // Los componentes se cargarán normalmente cuando se necesiten
    });
  };

  try {
    // Preload Home page - componente más crítico
    safeImport('../pages/Home');

    // Preload commonly accessed pages con manejo de errores
    const commonPagesTimeout = setTimeout(() => {
      try {
        safeImport('../pages/Services');
        safeImport('../pages/About');
      } catch {
        // Manejar silenciosamente errores
      }
    }, 2000);

    // Preload other pages after initial load con manejo de errores
    const otherPagesTimeout = setTimeout(() => {
      try {
        safeImport('../pages/Contact');
        safeImport('../pages/Planes');
      } catch {
        // Manejar silenciosamente errores
      }
    }, 5000);

    // Limpiar timeouts si el componente se desmonta
    return () => {
      clearTimeout(commonPagesTimeout);
      clearTimeout(otherPagesTimeout);
    };
  } catch {
    // Manejar silenciosamente cualquier error en la precarga
    // No afecta la funcionalidad principal de la aplicación
    return () => {}; // Devolver una función de limpieza vacía
  }
};
